export default __webpack_public_path__ + "static/media/rocket.5b9b8440.png";